import * as tslib_1 from "tslib";
import { useState, useLayoutEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
import ddt from '@wix/da-ddt';
var logger = ddt.createLogger('folding');
var THROTTLE_TIMEOUT = 200;
// Measures children of an element and calculates which children should be hidden
// to fit into a certain number of rows. It identifies children based on text content.
// for example usage see src/Tags/Tags.tsx
export function useChildrenFolding(items, // the list of items that the children are rendered from
_a) {
    var _b = _a.maxLines, maxLines = _b === void 0 ? 1 : _b, _c = _a.itemSpacing, itemSpacing = _c === void 0 ? 0 : _c, _d = _a.endPadding, endPadding = _d === void 0 ? 0 : _d, maxItemWidth = _a.maxItemWidth, getItemKey = _a.getItemKey, _e = _a.excludeChild, excludeChild = _e === void 0 ? function () { return false; } : _e;
    var containerRef = useRef(null);
    var _f = useState(0), overflowItems = _f[0], setOverflowItems = _f[1];
    var _g = useState({}), childWidths = _g[0], setChildWidths = _g[1];
    useLayoutEffect(function () {
        var calculateOverflow = throttle(function () {
            var container = containerRef.current;
            if (!container) {
                return;
            }
            var newTagWidths = tslib_1.__assign({}, childWidths);
            var updateTagWidths = false;
            var containerWidth = container.getBoundingClientRect().width;
            var lastRowWidth = containerWidth - endPadding;
            var rows = 1;
            var newOverflowItems = 0;
            var currentRowWidth = 0;
            Array.prototype.forEach.call(container.children, function (element) {
                if (excludeChild(element)) {
                    return;
                }
                var tagText = element.textContent || '';
                // we only measure if we haven't done so before - so collapsed
                // long items keep the right size
                if (!newTagWidths.hasOwnProperty(tagText)) {
                    newTagWidths[tagText] = Math.ceil(element.getBoundingClientRect().width);
                    updateTagWidths = true;
                }
                var tagWidth = (maxItemWidth
                    ? Math.min(newTagWidths[tagText], maxItemWidth)
                    : newTagWidths[tagText]) + itemSpacing;
                if (rows < maxLines) {
                    if (currentRowWidth + tagWidth < containerWidth) {
                        currentRowWidth += tagWidth;
                        logger.log("Row " + rows + ": " + tagText + " (" + tagWidth + "/" + currentRowWidth + ")");
                    }
                    else {
                        logger.log("Row " + rows + " final width: " + currentRowWidth);
                        rows++;
                        currentRowWidth = tagWidth;
                        logger.log("Row " + rows + ": " + tagText + " (" + tagWidth + "/" + currentRowWidth + ")");
                    }
                }
                else if (rows === maxLines &&
                    currentRowWidth + tagWidth < lastRowWidth) {
                    currentRowWidth += tagWidth;
                    logger.log("Row " + rows + ": " + tagText + " (" + tagWidth + "/" + currentRowWidth + ")");
                }
                else {
                    if (rows === maxLines) {
                        logger.log("Row " + rows + " final width: " + (currentRowWidth + endPadding));
                    }
                    rows = maxLines + 1;
                    newOverflowItems++;
                    logger.log("Overflown: " + tagText + " (" + tagWidth + ")");
                }
            });
            // Only set overflow when it has changed, stops death loop
            if (overflowItems !== newOverflowItems) {
                logger.log("Set overflow was: " + overflowItems + " now: " + newOverflowItems);
                setOverflowItems(newOverflowItems);
            }
            if (updateTagWidths) {
                logger.log("Set child width");
                setChildWidths(newTagWidths);
            }
        }, THROTTLE_TIMEOUT, { leading: true });
        if (overflowItems === 0) {
            calculateOverflow();
        }
        window.addEventListener('resize', calculateOverflow);
        return function () { return window.removeEventListener('resize', calculateOverflow); };
    }, [
        containerRef,
        childWidths,
        setChildWidths,
        overflowItems,
        setOverflowItems,
        maxLines,
        itemSpacing,
        endPadding,
        maxItemWidth,
    ]);
    var sizedItems = items.map(function (item, index) {
        var key = getItemKey(item);
        var width = childWidths[key];
        return {
            item: item,
            width: width,
            isOverflow: index >= items.length - overflowItems,
            isOversized: maxItemWidth ? (width || 0) > maxItemWidth : false,
        };
    });
    return { sizedItems: sizedItems, hasHidden: overflowItems > 0, containerRef: containerRef };
}
//# sourceMappingURL=useChildrenFolding.js.map